import { render, staticRenderFns } from "./EmployeesWidget.vue?vue&type=template&id=6b6e6f21&scoped=true"
import script from "./EmployeesWidget.vue?vue&type=script&lang=js"
export * from "./EmployeesWidget.vue?vue&type=script&lang=js"
import style0 from "./EmployeesWidget.vue?vue&type=style&index=0&id=6b6e6f21&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e6f21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6e6f21')) {
      api.createRecord('6b6e6f21', component.options)
    } else {
      api.reload('6b6e6f21', component.options)
    }
    module.hot.accept("./EmployeesWidget.vue?vue&type=template&id=6b6e6f21&scoped=true", function () {
      api.rerender('6b6e6f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/EmployeesWidget.vue"
export default component.exports